import { Outlet } from 'react-router-dom';

import NavBar from '@/components/navbar/NavBar';
import { AuthProvider } from '@/context/AuthContext';

export default function Root() {
	return (
		<>
			<AuthProvider>
				<NavBar />
				<div id="pages" className="flex flex-col flex-1">
					<Outlet />
				</div>
			</AuthProvider>
		</>
	);
}
